import Image from '@/features/shared/Image';
import { MuiCard, MuiCardContent, MuiTypography } from '@/features/shared/material-ui';
import RichText from '@/features/shared/RichText';
import { Theme } from '@/utils/constants';
import clsx from 'clsx';
import React from 'react';
import useContentCardStyles from './PortalCarouselContentCard.styles';

const PortalCarouselContentCard = ({ cardDescription, cardCategory, cardImage }: CardType) => {
  const classes = useContentCardStyles();
  const [category = ''] = !Array.isArray(cardCategory) ? [cardCategory] : cardCategory;

  const categoryLabel = category?.label || category || '';

  return (
    <MuiCard className={clsx(classes.root, 'gntc-portal-carousel-content-card')} elevation={4}>
      {cardImage && (
        <Image
          image={cardImage}
          type="card"
          base="small"
          size="cover"
          className={classes.image}
          roundedCorners={false}
        />
      )}
      <MuiCardContent className={clsx(classes.cardContent, 'portal-carousel-card-content')}>
        {categoryLabel && (
          <MuiTypography
            variant="overline"
            component="h5"
            className={clsx(classes.contentCategory, 'content-card-category')}
          >
            {categoryLabel}
          </MuiTypography>
        )}
        {cardDescription && (
          <div className={classes.contentDescription}>
            <RichText theme={Theme.dark} content={cardDescription} customStyles />
          </div>
        )}
      </MuiCardContent>
    </MuiCard>
  );
};

export default PortalCarouselContentCard;
